import * as actionTypes from './actionTypes';

export const fetchHelpContent = (HelpType) => {
  return {
    type: actionTypes.FETCH_HELP_CONTENT,
    HelpType,
  };
};

export const fetchHelpContentStart = (HelpType) => {
  return {
    type: actionTypes.FETCH_HELP_CONTENT_START,
    HelpType,
  };
};

export const fetchHelpContentSuccess = (HelpContent, HelpCount) => {
  return {
    type: actionTypes.FETCH_HELP_CONTENT_SUCCESS,
    HelpContent,
    HelpCount,
  };
};

export const fetchHelpContentFailed = (error) => {
  return {
    type: actionTypes.FETCH_HELP_CONTENT_FAILED,
    error,
  };
};
